import { TeacherPlatformGatingEventRoutingType } from "features/teachers/features/gating/types";

import {
  route,
  string
} from "seneca-common/utils/routing/react-router-typesafe-routes/dom";
import { classAndAssignmentArrayType, locationType } from "./types";

export const ROUTES = {
  DASHBOARD: route(
    "dashboard",
    {},
    {
      CLASSES: route(
        "classes",
        {},
        {
          ASSIGNMENTS: route(
            "assignments",
            {},
            {
              UPCOMING: route("upcoming"),
              PAST: route("past")
            }
          )
        }
      )
    }
  ),
  TEACHER: route(
    "teacher",
    { state: { teacherBackground: locationType } },
    {
      SETTINGS: route(
        "settings",
        { state: { settingsBackground: locationType } },
        {
          PERSONAL_INFORMATION: route(
            "personal-information",
            {},
            { CHANGE_EMAIL: route("change-email") }
          ),
          PASSWORD: route("password"),
          NOTIFICATIONS: route("notifications")
        }
      ),
      CLASS: route(
        "class/:classId",
        {
          params: { classId: string().default("") }
        },
        {
          ASSIGNMENTS: route(
            "assignments",
            {},
            {
              OVERVIEW: route("overview"),
              ASSIGNMENT: route("assignment/:assignmentId", {
                params: { assignmentId: string().default("") }
              })
            }
          )
        }
      ),
      MIS_EXPIRY: route("mis-expiry", {
        state: {
          gatingEvent: TeacherPlatformGatingEventRoutingType
        }
      })
    }
  )
};

export const MODAL_ROUTES = route(
  "",
  { state: { background: locationType } },
  {
    UNLOCK_DARK_MODE: route("unlock-dark-mode"),
    SHARE_ASSIGNMENT: route("share-assignment", {
      searchParams: {
        classId: string().default(""),
        assignmentId: string().default("")
      }
    }),
    SHARE_ASSIGNMENTS: route("share-assignments", {
      state: {
        multipleAssignments: classAndAssignmentArrayType
      }
    })
  }
);
